import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../../../../../assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";
import Page1 from "./Page1";
import Page2 from "./Page2";
import { generateImageSrc } from "../../../../../../utils/generateImageSrc";
import headerImg from "../assets/header.jpg";
import footerImg from "../assets/footer.jpg";
import SecondPartyTbl from "./SecondPartyTbl";
import FirstPartyTbl from "./FirstPartyTbl";
import SignaturesTbl from "./SignaturesTbl";
import PageLayout from "../MonthlyContract/PageLayout";


export default function HourlyContract({ contractDetails, generatedTitles }) {
  Font.register({
    family: "Arabic",
    src: ArabicRegular,
  });
  Font.register({
    family: "ArabicBold",
    src: ArabicBold,
  });
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      paddingHorizontal: 20,
      // paddingVertical: 30,
      fontSize: 9,
      paddingBottom: 100,
    },
    arabic: {
      fontFamily: "Arabic",
      flexDirection: "row",
      textAlign: "right",
      writingMode: "horizontal-tb",
      direction: "rtl",
      fontSize: "9px",
    },
  });

  return (
    <Document>
      <PageLayout pageNo={1} company={contractDetails?.visa_provider}>
        <Page1
          generatedTitles={generatedTitles}
          contractDetails={contractDetails}
          styles={styles}
        />
        <Page2 contractDetails={contractDetails} />

        <Text style={{ marginTop: 15, fontFamily: "Helvetica-Bold" }}>
          lll. INFORMATION SHEET:
        </Text>
        <FirstPartyTbl contractDetails={contractDetails} styles={styles} />
        <SecondPartyTbl contractDetails={contractDetails} styles={styles} />
        <SignaturesTbl contractDetails={contractDetails} />
      </PageLayout>
    </Document>
  );
}
